<template>
    <ValidationProvider v-slot="{ errors }" name="SectionNo" rules="required">
        <AdvancedDropdown v-model="modelValue" v-bind="$attrs" :options="options" :disabled="false" :can-add-new="false"
            label="SectionNo" size="sm">
            <template v-slot:label> Section No <span class="text-danger">*</span> </template>

            <template v-slot:button-content>
                <template v-if="!!selectedOption">{{ selectedOption.text }}</template>
                <template v-else>Select</template>
            </template>

        </AdvancedDropdown>

        <div v-if="!!errors.length" class="invalid-feedback d-block">
            {{ errors[0] }}
        </div>
    </ValidationProvider>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'
import { ValidationProvider } from 'vee-validate'

import {
    useCurrentUser
} from '@composables'

import { BaseIcon } from '@components/base'
import { AdvancedDropdown } from '@components/advanced'

export default defineComponent({
    name: 'CashCallFormSectionNo',
    components: {
        ValidationProvider,

        BaseIcon,

        AdvancedDropdown


    },
    props: {
        value: {
            type: Array,
            default: () => []
        }
    },
    emits: ['input'],
    setup(props, { emit }) {
        const { isSuperUser } = useCurrentUser()


        const modelValue = computed({
            get: () => props.value,
            set: (newValue) => emit('input', newValue)
        })

        const options = [{ text: '', value: '' }]

        const selectedOption = ''

        return {
            isSuperUser,
            modelValue,            
            options,
            selectedOption
        }
    }
})
</script>

<style scoped>
.advanced-dropdown>>>.dropdown-toggle {
    max-width: 214px;
}

.advanced-dropdown>>>.dropdown-menu .list-group-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.advanced-dropdown>>>.dropdown-menu .list-group-item.disabled {
    color: #fff;
    background-color: #1c4a50;
    pointer-events: initial;
}
</style>